import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Formik } from "formik";
import { useLocation } from "react-router-dom";
import { Grid } from "@material-ui/core";
import {
  Title,
  Margin,
  Input,
  Button,
  ErrorMessage,
  Loading,
} from "~/components/elements";
import { schema } from "./validation";
import { Creators as SignUpActions } from "~/store/modules/signUp/actions";
import { Creators as AuthenticationActions } from "~/store/modules/authentication/actions";
import isMobile from "~/hooks/isMobile";

import * as S from "./styles";

export default function FormSignUpComplement() {
  const mobile = isMobile();
  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const paramObj = {};
    for (const [key, value] of queryParams.entries()) {
      paramObj[key] = value;
    }
  }, [location]);


  const sending = useSelector((state) => state.signUp.sign.sending);
  const errorMessage = useSelector((state) => state.signUp.sign.errorMessage);
  const initialValues = {
    ParticipanteHash: useSelector(
      (state) => state.authentication.auth.user.ParticipanteHash
    ),
    Email: "",
    ConfirmaEmail: "",
    Senha: "",
    ConfirmaSenha: "",
  };

  const url = process.env.REACT_APP_HOST_URL;
  const origin = process.env.REACT_APP_ORIGIN;

  useEffect(() => {
    dispatch(AuthenticationActions.purgeAuthentication());
    dispatch(SignUpActions.setSignUpData());
  }, [dispatch]);

  return (
    <S.FormHolder>
      <Margin mt={6} mb={mobile ? 3 : 4}>
        <Title as="2" level="6" primary>
          <strong>
            Informações para criar sua conta
          </strong>
        </Title>
      </Margin>
      <Margin mb={3}>
        <Formik
          initialValues={initialValues}
          validationSchema={schema}
          onSubmit={(values, { setSubmitting }) => {
            setSubmitting(false);
            dispatch(SignUpActions.setSignUpData());
            const payloadValues = {
              ...values,
              AceitaReceberNoticias: true,
              AceitaTermosLegais: true,
              AceitaRegulamento: true,
              Url: url,
              Origin: origin,
            };
            delete payloadValues.ConfirmaEmail;
            delete payloadValues.ConfirmaSenha;

            dispatch(SignUpActions.sendSignUpForm(payloadValues));
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            setFieldValue,
            isValid,
            dirty,
          }) => (
            <S.FormLimiter onSubmit={handleSubmit}>
              <S.GridHolder>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={12}>
                    <Margin mb={mobile ? 4 : 3}>
                      <Input
                        label="Nome completo"
                        placeholder="Digite seu nome"
                        htmlFor="nameFieldFormSignup"
                        name="Nome"
                        required
                        value={values.Nome}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        errors={touched.Nome && errors.Nome}
                        valid={!errors.Nome}
                      />
                    </Margin>
                    <Margin mb={mobile ? 4 : 3}>
                      <Input
                        label="E-mail"
                        placeholder="Digite seu melhor e-mail"
                        htmlFor="emailFieldFormSignup"
                        name="Email"
                        value={values.Email}
                        onChange={handleChange}
                        onBlur={(name, value) => {
                          handleBlur(name, value);
                          dispatch(
                            SignUpActions.verifyEmail({ Email: values.Email })
                          );
                        }}
                        errors={touched.Email && errors.Email}
                        valid={!errors.Email}
                        required
                      />
                    </Margin>
                    <Margin mb={mobile ? 4 : 3}>
                      <Input
                        label="Confirmação de e-mail"
                        placeholder="Digite novamente seu e-mail"
                        htmlFor="emailConfirmFieldFormSignup"
                        name="ConfirmaEmail"
                        value={values.ConfirmaEmail}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        errors={touched.ConfirmaEmail && errors.ConfirmaEmail}
                        valid={!errors.ConfirmaEmail}
                        required
                      />
                    </Margin>
                    <Margin mb={mobile ? 4 : 3}>
                      <Input
                        type="password"
                        label="Senha"
                        placeholder="Digite uma senha"
                        htmlFor="passwordFieldFormSignup"
                        name="Senha"
                        value={values.Senha}
                        maxLength={32}
                        onChange={handleChange}
                        successIcon={true}
                        showHidePassword={true}
                        validateOnBlur={false}
                        required
                      />
                    </Margin>
                    <Margin mb={mobile ? 8 : 6}>
                      <Input
                        type="password"
                        label="Confirmar senha"
                        placeholder="Digite novamente sua senha"
                        htmlFor="passwordConfirmFieldFormSignup"
                        name="ConfirmaSenha"
                        value={values.ConfirmaSenha}
                        maxLength={32}
                        onChange={handleChange}
                        successIcon={true}
                        showHidePassword={true}
                        validateOnBlur={false}
                        required
                      />
                    </Margin>
                  </Grid>
                </Grid>
              </S.GridHolder>
              <S.ButtonsGrid
                container
                justifyContent="space-between"
                direction={mobile ? "column-reverse" : "row"}
              >
                <Margin mb={mobile ? 3 : 0}>
                  <Button
                    className="animation-size"
                    color={
                      !isValid || !dirty || sending
                        ? "disabled"
                        : "primary"
                    }
                    disabled={!isValid || !dirty || sending}
                    type="submit"
                    id="nextButtonFormSignup"
                  >
                    {sending ? <Loading button /> : "AVANÇAR >"}
                  </Button>
                </Margin>
              </S.ButtonsGrid>
              {errorMessage && (
                <Margin mt={mobile ? 3 : 5}>
                  <ErrorMessage>{errorMessage}</ErrorMessage>
                </Margin>
              )}
            </S.FormLimiter>
          )}
        </Formik>
      </Margin>
    </S.FormHolder>
  );
}
